import { createReducer, on } from '@ngrx/store';
import * as NavigationStateActions from './navigation-state.actions';

export const navigationStateFeatureKey = 'navigationState';

export interface State {
  hasSubmenu: boolean;
  mobileMenuOpenOpen: boolean;
  hasSave: boolean;
  disableMobileMenu: boolean;
  isOpen: boolean;
  forceSubNavigationOpen: boolean;
}

export const initialState: State = {
  hasSubmenu: false,
  mobileMenuOpenOpen: false,
  hasSave: false,
  disableMobileMenu: false,
  isOpen: false,
  forceSubNavigationOpen: false,
};

export const reducer = createReducer(
  initialState,

  on(NavigationStateActions.loadNavigationStates, (state) => state),
  on(
    NavigationStateActions.navigationSetHasSubmenuState,
    (state, { hasSubmenu }) => ({
      ...state,
      hasSubmenu,
    })
  ),
  on(NavigationStateActions.navigationSetHasSave, (state, { hasSave }) => ({
    ...state,
    hasSave,
  })),
  on(NavigationStateActions.navigationSetIsOpen, (state, { isOpen }) => ({
    ...state,
    isOpen,
  })),
  on(
    NavigationStateActions.navigationMobileSubmenuToggleOpenState,
    (state) => ({
      ...state,
      mobileMenuOpenOpen: !state.mobileMenuOpenOpen,
    })
  ),
  on(NavigationStateActions.navigationMobileSubmenuClose, (state) => ({
    ...state,
    mobileMenuOpenOpen: false,
  })),
  on(NavigationStateActions.navigationForceSubNavigationOpen, (state) => ({
    ...state,
    forceSubNavigationOpen: true,
  })),
  on(
    NavigationStateActions.navigationSetMobileMenuDisabled,
    (state, { disabled }) => ({
      ...state,
      disableMobileMenu: disabled,
    })
  )
);
